import { useCallback } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

export const useSetExtendsKeys = () => {
    const { control, setValue, getValues } = useFormContext()
    const breakKeys = useWatch({ name: 'breakPoint.breakKeys', control })

    const handleSetBreakKey = useCallback(
        (name: string) => {
            // const breakKeys = getValues('breakPoint.breakKeys')
            const keyPaths = new Set(breakKeys || [])
            const list = name.split('.')
            const key = list.includes('breakPoint') ? list.slice(1).join('.') : name
            if (!key) {
                return
            }
            keyPaths.add(key)
            setValue('breakPoint.breakKeys', [...keyPaths])
        },
        [breakKeys, setValue]
    )

    const handleSetBreakKeys = useCallback(
        (names: string[]) => {
            // const breakKeys = getValues('breakPoint.breakKeys')
            const keyPaths = new Set(breakKeys || [])
            names.forEach(name => {
                const list = name.split('.')
                const key = list.includes('breakPoint') ? list.slice(1).join('.') : name
                if (!key) {
                    return
                }
                keyPaths.add(key)
            })
            setValue('breakPoint.breakKeys', [...keyPaths])
        },
        [breakKeys, setValue]
    )

    const handleRemoveBreakKey = useCallback(
        (name: string) => {
            const breakKeys = getValues('breakPoint.breakKeys')
            const keyPaths = new Set(breakKeys || [])
            const list = name.split('.')
            const key = list.includes('breakPoint') ? list.slice(1).join('.') : name
            if (!key) {
                return
            }
            keyPaths.delete(key)
            setValue('breakPoint.breakKeys', [...keyPaths])
        },
        [getValues, setValue]
    )

    const handleRemoveBreakKeys = useCallback(
        (names: string[]) => {
            let breakKeys: string[] = getValues('breakPoint.breakKeys')
            names.forEach(name => {
                breakKeys = breakKeys?.filter(key => !key.includes(name)) || []
            })
            setValue('breakPoint.breakKeys', breakKeys)
        },
        [getValues, setValue]
    )

    const handleClearBreakKey = useCallback(() => {
        setValue('breakPoint.breakKeys', [])
    }, [setValue])

    return {
        handleSetBreakKey,
        handleRemoveBreakKey,
        handleSetBreakKeys,
        handleClearBreakKey,
        handleRemoveBreakKeys,
        breakKeys
    }
}
